import React from 'react';

import { Stack, xcss } from '@atlaskit/primitives';

import { BulkCreateBody } from './BulkCreateBody';
import { BulkCreateHeader } from './BulkCreateHeader';
import { BulkCreateFooter } from './BulkCreateFooter';
import { SidePanelWrapper } from './SidePanelWrapper';

const contentStyles = xcss({
	width: '100%',
	height: '100%',
	display: 'flex',
	flexDirection: 'column',
	flexWrap: 'nowrap',
});

export const AiBulkDefaultView = ({ onClose }: { onClose: () => void }) => (
	<SidePanelWrapper>
		<Stack xcss={contentStyles}>
			<BulkCreateHeader onClose={onClose} />
			<BulkCreateBody />
			<BulkCreateFooter />
		</Stack>
	</SidePanelWrapper>
);
